// ----------------------------------------------------------------------------

function getPositionColumn(elementColumn: HTMLTableCellElement): Record<string, any> {
    const elRow = elementColumn.parentElement as HTMLTableRowElement;
    const rowIndex = elRow.rowIndex;
    const columnIndex = elementColumn.cellIndex;

    return {
        rowIndex,
        columnIndex,
    };
}

// ----------------------------------------------------------------------------

export default getPositionColumn;
